import React, { useEffect, useState, useRef, useContext } from "react";
import axios from "axios";
import { Helmet } from "react-helmet";
import MobileVersion from "../components/mobileVersion/MobileVersion";
import useWindowSize from "../hooks/useWindowSize";
import classes from "./AddCustomer.module.scss";
import { JsonEditor as Editor } from "jsoneditor-react";
import { Container, Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import LoadingDots from "../components/UI/LoadingDots";
import Button from "../components/UI/Button";
import { diff } from "jsondiffpatch";
import AddCustomerDetails from "../components/addCustomerElements/AddCustomerDetails";
import { OrgIdContext, CustomerRelations, ClientTypes } from "../store/orgId_context";
import { useCallback } from "react";
import AddCustomerRequest from "../components/addCustomerElements/AddCustomerRequests";
import AddCustomerResponse from "../components/addCustomerElements/AddCustomerResponse";
import OrganizationId from "../components/addCustomerElements/OrganizationId";
import JSONPretty from "../components/jsonPrettyOverride/JSONPretty";
import UserId from "../components/addCustomerElements/UserId";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useQuery } from '@tanstack/react-query'
import { DDD, E2Data } from "../lib/ddd/ddd";
import ButtonLink from "../components/UI/ButtonLink";
import GenericModal from "../components/UI/GenericModal";
import UsersIds from "../components/addCustomerElements/UsersIds";
import { GenericTooltip } from "../components/integrationWizard/form/GenericTooltip";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';


const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const ddd = new DDD(apiRequestAddress);
/*const e2Data = new E2Data("EU_CustomerObject");
e2Data.format="Full";
e2Data.filter = "Valid = true";
e2Data.orderBy = "OrderInObject asc";
e2Data.take = null;*/
const basic={
  format:"Full",
  filter:"Valid = true",
  orderBy:"OrderInObject asc",
  take:null
}

const AddCustomer = () => {
  const { width } = useWindowSize();
  const [editorObject, setEditorObject] = useState(null);
  const [isLoading, setIsLoading] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [apiData, setApiData] = useState(null);
  const jsonEditorRef = useRef(null);
  const [currentCurl, setCurrentCurl] = useState(null);
  const [currentJsonrpc, setCurrentJsonrpc] = useState(null);
  const [currentFetch, setCurrentFetch] = useState(null);
  const [response, setResponse] = useState(null);
  const [isResLoading, setIsResLoading] = useState(null);
  const [error,setError] =  useState(null);
  const [rows, setRows] = useState();
  const [loadUsers, setLoadUsers] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [formValidation, setFormValidation] = useState();
  const [formErrors, setFormErrors] = useState({});
  const [formErrorsText, setFormErrorsText] = useState();
  const { connectionKey, setConnKeyHandler, integrationDevice, mainOrgId, sessionInfo, customerRelation, clientType } = useContext(OrgIdContext);
  const [e2Data] = useState(E2Data.WithConnectionKey(apiRequestAddress, integrationDevice,"EU_CustomerObject").ApplyParams(basic));

  if(clientType === ClientTypes.ISV){
    e2Data.filter = "Valid = true AND ForISV = true";
  }else if(clientType === ClientTypes.AccService){
    e2Data.filter = "Valid = true AND ForAccService = true";
  }else{
    e2Data.filter = "Valid = true AND ForPartner = true";
  }

  const onToggleModalHandler = (bool) => setIsModalOpen(bool);

  const {isPending : tDataPending, data : tData} = useQuery({
    queryKey: ["EUeInvoices.GetCurrentTData"],
    queryFn: () => ddd.Rpc_ExecuteExtension("EUeInvoices.GetCurrentTData"),
    enabled : !connectionKey
  })

  const {isPending : objDataPending, data : customerObjData} = useQuery({
    queryKey: ["EU_CustomerObject",e2Data.GetParamsObject()],
    queryFn: () => e2Data.GetData(),
    staleTime: Infinity,
  })

  const {isPending : usersPending, data : usersData} = useQuery({
    queryKey: ["EUeInvoices.GetContentData",{Type:"orgusers"}],
    queryFn: () => ddd.Rpc_ExecuteExtension("EUeInvoices.GetContentData", {Type:"orgusers"}),
    enabled : loadUsers
  })

  useEffect(() =>{
    if(!connectionKey && tData){
      setConnKeyHandler(tData.result?.Result?.ConnectionKey)
    }
  }, [connectionKey, setConnKeyHandler,tDataPending,tData])

  useEffect(() =>{
    if(formValidation === false){
      setFormErrors({});
      setFormErrorsText(null);
    }
  },[formValidation])

  const setCallExamples = useCallback(
    (object) => {
      const curlCmd = `curl -X POST https://${
        window.location.hostname
      }/api/service/EUeInvoices.AddCustomer -H "Authorization: IoT ${connectionKey}:EUeInvoices" -H "Content-Type: application/json" -d ${JSON.stringify(
        JSON.stringify(object)
      )}`;

      const requestBody = `RpcClient.headers['Authorization'] = 'IoT ${connectionKey}:EUeInvoices'
      RpcClient.call("Extension.Execute", { extension: "EUeInvoices.AddCustomer", args: ${JSON.stringify(
        object
      )} }).done(res => {}).post()`;

      const fetchBody = `fetch(endpoint, {
        method: "POST",
        credentials: "omit",
        headers: {
          "Content-Type": "application/json",
          Authorization: "IoT ${connectionKey}:EUeInvoices",
          "D3Pro-PreferAuthorizationOverSession": "True",
        },
        body: ${JSON.stringify(object)},
      })
        .then((response) => {})
        .catch((error) => {});`;

      setCurrentCurl(curlCmd);
      setCurrentJsonrpc(requestBody);
      setCurrentFetch(fetchBody);
    },
    [connectionKey]
  );

  useEffect(() => {
    setIsLoading(true);

    if(objDataPending ||!customerObjData)
      return;

    setIsLoading(false);
    const data = customerObjData.result?.data;
    if(!data)
      return setError("Unable to load data");

    setRows(data);
    
    const emptyObj = {};
    data.forEach(item => {
      if(customerRelation !== CustomerRelations.None){

      }
      if(item.NameInObject)
        emptyObj[item.NameInObject] = null;
    });
    emptyObj.MyAccessAsAdminId = sessionInfo?.User?.Id;
    emptyObj.MyAccessAsAdmin = true;
    if(emptyObj.hasOwnProperty("FromDomain"))
      emptyObj.FromDomain = window.location.hostname;

    //delete emptyObj.CustomerRelation;
    //delete emptyObj.ClientType;
    //delete emptyObj.TransformerId;
    if(customerRelation === CustomerRelations.None){
      delete emptyObj.AdminName;
      delete emptyObj.AdminLastName;
      delete emptyObj.AdminEmail;
    }

    const upperObj = {};
    upperObj.MyOrgId = mainOrgId;
    //upperObj.ByWho = null;
    upperObj.CustomerObj = emptyObj;
    console.log(upperObj);
    setCallExamples(upperObj);
    setEditorObject(upperObj);
  },[objDataPending,customerObjData]);


 useEffect(() => {
    //setIsLoading(true);

    axios
      .post(
        apiRequestAddress,
        {
          jsonrpc: "2.0",
          method: "Metadata.DescribeService",
          params: {
            //service: "EUeInvoices.AddCustomer",
            service: "EUeInvoices.AddCustomer",
          },
          id: 56156,
        },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        setApiData(res.data.result);

        /*const emptyObject = {};
        emptyObject.AdminUserId = sessionInfo?.User?.Id;
        for (const key in res.data.result.properties.CustomerObj.properties) {
          if(key === "TransformerId")
            continue;
          emptyObject[key] = null;
        }
        
        if(customerRelation !== CustomerRelations.None){
          emptyObject.AdminName = null;
          emptyObject.AdminLastName = null;
          emptyObject.AdminEmail = null;
        }

        const upperObj = {};
        upperObj.MyOrgId = mainOrgId;
        //upperObj.ByWho = null;
        upperObj.CustomerObj = emptyObject;
        setCallExamples(upperObj);
        setEditorObject(upperObj);
        setIsLoading(false);*/
      });
  }, [/*setCallExamples, connectionKey, mainOrgId*/]);

  useEffect(() => {
    if (jsonEditorRef.current) {
      const jsonEditorInstance = jsonEditorRef.current.jsonEditor;
      jsonEditorInstance.set(editorObject);
    }
    //setCallExamples({ CustomerObj: editorObject });
    setCallExamples(editorObject);
  }, [editorObject, setCallExamples]);

  const updateValueByKey = (key, newValue) => {
    for (let prop in editorObject) {
      if (prop === key) {
        setEditorObject((prevEditorObject) => ({
          ...prevEditorObject,
          [key]: newValue.length > 0 ? newValue : null,
        }));
        
        renderFormField(key);
      }

      if(prop==="CustomerObj"){
        for(let field in editorObject[prop]){
          if(field===key){
            setEditorObject((prevEditorObject) => ({
              ...prevEditorObject,
              "CustomerObj" : {...prevEditorObject.CustomerObj, [key]: newValue.length > 0 ? newValue : null}
            }));
          }
        }
      }
    }
  };

  const handleEditorChange = (e) => {
    const spottedDif = diff(editorObject, e);
    let changedKey = Object.keys(spottedDif)[0];
    let newValue = spottedDif[changedKey][1];
    updateValueByKey(changedKey, newValue);
  };

  const handleFieldChange = (fieldName, value) => updateValueByKey(fieldName, value);

  const isDisabled = (fieldName) =>{
    return fieldName==="MyOrgId" || 
           fieldName==="MyAccessAsAdmin" ||
           fieldName==="MyAccessAsAdminId"||
           fieldName==="FromDomain"
  }

  const renderFormField = (fieldName, style) => {
    if(fieldName === "ByWho"){
      return (<div key={fieldName} className="w-100" style={style}>
        <label>{fieldName}</label>
        <select
        name={fieldName}
        value={editorObject[fieldName]}
        onChange={(e) => {handleFieldChange(fieldName, e.target.value);}}
        >
            <option value={null} key="null"></option>
            <option value={"AccService"} key="AccService">AccService</option>
            <option value={"Partner"} key="Partner">Partner</option>
        </select>
      </div>)
    }
    return (
      <div key={fieldName} className="w-100" style={style}>
        <label>{fieldName}{getTooltip(fieldName)}{getError(fieldName)}</label>
        <input
          type="text"
          defaultValue=""
          disabled = {isDisabled(fieldName)}
          value={getValueForFieldName(fieldName)}
          style={getError(fieldName) !== null ? {borderColor:"red"}: {}}
          onChange={(e) => handleFieldChange(fieldName, e.target.value)}
          // onBlur={(e) => handleFieldChange(fieldName, e.target.value)}
        />
      </div>
    );
  };

  const getValueForFieldName = (fieldName) => {
    if(editorObject[fieldName])
      return editorObject[fieldName];

    if(editorObject?.CustomerObj && editorObject?.CustomerObj[fieldName])
      return editorObject?.CustomerObj[fieldName];
    return null;
  }

  const getTooltip = (fieldName) =>{
    const info = getFieldInfo(fieldName);
    if(!info)
      return;
    const tooltip = getTooltipText(info);
    if(!tooltip)
      return;
    return (
      <OverlayTrigger placement="left" overlay={<Tooltip>{tooltip}</Tooltip>}>
          <HelpOutlineIcon style={{marginLeft:"0.5rem", fontSize:"1rem"}}/>
      </OverlayTrigger>
    )
  }

  const getTooltipText = (fieldInfo) =>{
    if(clientType === ClientTypes.ISV && fieldInfo.ISVDesc)
        return fieldInfo.ISVDesc;
    if(clientType === ClientTypes.AccService && fieldInfo.AccSDesc)
        return fieldInfo.AccSDesc;
    if(clientType===null && fieldInfo.PartnerDesc)
        return fieldInfo.PartnerDesc;
    return null;
}

  const getError = (fieldName) =>{
    if(!formErrors[fieldName])
      return null;
    return (
      <OverlayTrigger placement="left" overlay={<Tooltip>{fieldName} is required</Tooltip>}>
          <ErrorOutlineIcon style={{marginLeft:"0.5rem", fontSize:"1rem",  color:"red"}}/>
      </OverlayTrigger>
    )
  }

  const validateFields = () =>{
    setFormErrorsText(null);
    setFormErrors({});
    if(!rows) return;
    let errors = {};
    rows.forEach(field => {
      if(field.MandatoryForISV && !getValueForFieldName(field.NameInObject))
        errors[field.NameInObject] = true;
    })
    setFormErrorsText("Some information is missing");
    setFormErrors(errors);
    return errors;
  }

  const getFieldInfo = (fieldName) =>{
    return rows.find(item => item.NameInObject == fieldName || item.FieldName == fieldName);
  }


  const onSubmitCall = () => {
    if(formValidation && Object.keys(validateFields()).length > 0)
      return;
    setIsResLoading(true);
    axios
      .post(
        process.env.REACT_APP_API_ENDPOINT ||
          window.location.origin + "/json.rpc",
        {
          jsonrpc: "2.0",
          method: "Extension.Execute",
          params: {
            extension: "EUeInvoices.AddCustomer",
            args: editorObject,
          },
          id: 31,
        },
        {
          withCredentials: true,
          headers: {
            Authorization: `IoT ${integrationDevice}:EUeInvoices`
          },
        }
      )
      .then((res) => {
        setResponse(res.data);
        setIsResLoading(false);
      });
  };

  const openUsers = () =>{
    if(!loadUsers)
      setLoadUsers(true);

    setModalShow(true);
  }

  return (
    <>
      <Helmet>
        <title>Add Customer | DDD Invoices</title>
      </Helmet>
      {width > 768 && (
        <div className={`w-100 d-flex flex-column p-5 ${classes.container}`}>
        <Container
          
        >
          <Row>
            <p>Each request must have your company Id (MyOrgId) included, so that the customer is included under your company.
            <OrganizationId />
            </p>
            <p>
              And we must assign which user has permissions to this company. In this example we will use your Id, so you will have permissions to this company.
              <UserId/>
              <div style={{fontSize:"0.8rem", marginTop:"0.5rem"}}>
              (If you wish to use a different user Id (MyAccessAsAdminId), you <Button onClick={openUsers}>click here</Button> to view other users assigned to your organization.)
              </div>
              
              <GenericModal title="Your users ID's" show={modalShow} onHide={() => setModalShow(false)} >
                <UsersIds loading={usersPending} userData={usersData?.result?.Result}/>
              </GenericModal>
            </p>
          </Row>
          {isLoading && <LoadingDots />}
          {!isLoading && (
            <>
              <Row>
                <Col className="col-12 mb-3">
                  <span className={classes.title}>Add customer</span>
                  <Button
                    className={`px-2 ms-2 ${classes["second-btn"]}`}
                    onClick={() => onToggleModalHandler(true)}
                  >
                    Integration details
                  </Button>
                </Col>
              </Row>
                  <Row>
                    <Col className="col-6 p-0">
                      <Row style={{justifyContent:"center"}}>Edit</Row>
                      <div style={{display:"flex", justifyContent:"space-between"}}>
                        <label>Enable form validation 
                          <GenericTooltip tooltip={"If enabled, this validation occurs only on client side. Its purpose is only to ease your entry of information in the form below."} fieldName={"validationOffon"} />
                        </label>
                        {formErrorsText && 
                          <div style={{color:"red"}}>
                            Errors 
                            <OverlayTrigger placement="left" overlay={<Tooltip>{formErrorsText}</Tooltip>}>
                                <ErrorOutlineIcon style={{marginLeft:"0.5rem", fontSize:"1rem", color:"red"}}/>
                            </OverlayTrigger>
                        </div>}
                        <div className="form-check form-switch text-center">
                        <input className="form-check-input" style={{float:"none"}} type="checkbox" role="switch" checked={formValidation} onChange={() =>setFormValidation(val => !val)}/>
                        </div>
                      </div>
                      <div className={classes["form-wrapper"]} style={{maxHeight:"75vh"}}>
                        <form>
                          {editorObject &&
                            Object.entries(editorObject).map(
                              ([fieldName, fieldConfig]) =>{
                                  if(fieldName==="CustomerObj") return;
                                  return renderFormField(fieldName)
                                }
                            )}
                            {editorObject &&
                            Object.entries(editorObject.CustomerObj).map(
                              ([fieldName, fieldConfig]) =>{
                                  if(fieldName.indexOf("Admin") === 0)
                                    return;
                                  return (
                                    <>
                                    {renderFormField(fieldName, {paddingLeft:"1rem"})}
                                    </>
                            )}
                            )}
                            {customerRelation !== CustomerRelations.None && 
                            <>
                            <div style={{justifyContent:"left"}}>
                              Also create user
                              <OverlayTrigger placement="left" overlay={<Tooltip>At the same time, also create a new user for your customer</Tooltip>}>
                                  <HelpOutlineIcon style={{marginLeft:"0.5rem", fontSize:"1rem"}}/>
                              </OverlayTrigger>
                            </div>
                              {renderFormField("AdminName", {paddingLeft:"1rem"})}
                              {renderFormField("AdminLastName", {paddingLeft:"1rem"})}
                              {renderFormField("AdminEmail", {paddingLeft:"1rem"})}
                            </>}
                        </form>
                      </div>
                    </Col>
                    <Col className="col-6 pe-3">
                      <Container className="d-flex flex-column h-100">
                        <Row style={{justifyContent:"center"}}>View</Row>
                        <Row style={{ flex: 1 }}>
                          <Col
                            className="d-flex p-0"
                            // style={{ maxHeight: "calc(66vh - 64px)" }}
                          >
                            <div className={classes["new-invoice-response"]}>
                              <div className={classes["editor-wrapper"]}>
                                <JSONPretty data={editorObject}/>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Container>
                    </Col>
                    
                  </Row>
                  <Row className="mt-3">
                    <Col className="col-6 pe-3">
                      <AddCustomerRequest
                        currentCurl={currentCurl}
                        currentJson={currentJsonrpc}
                        currentFetch={currentFetch}
                      />
                    </Col>
                    <Col className="col-6 p-0">
                      <div className="text-center">
                        <Button onClick={onSubmitCall} className="px-3">
                          Submit
                        </Button>
                      </div>
                      <AddCustomerResponse
                        response={response}
                        isLoading={isResLoading}
                      />
                    </Col>
                  </Row>
            </>
          )}
        </Container>
        </div>
      )}
      {isModalOpen && (
        <AddCustomerDetails
          toggleModal={onToggleModalHandler}
          isModalOpen={isModalOpen}
          data={apiData}
        />
      )}
      {width <= 768 && <MobileVersion />}
    </>
  );
};

export default AddCustomer;
